import { Button, Modal } from "antd";
import React, { useContext, useEffect, useState } from "react";

import { _formatMoney } from "../utils";
import { AuthContext } from "./../index";

import Hotline from "../assets/hotline.svg";
import ICheck from "../assets/icheck.png";
import IQuyenloi from "../assets/iquyenloi.svg";
import IThoihan from "../assets/ithoihan.svg";

const Package = () => {
  const { goStep, ArrPackage, SetDataIsu } = useContext(AuthContext);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [indexPackage, setIndexPackage] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  });

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const choosePackage = (data, i) => {
    setIndexPackage(i);
    SetDataIsu({ package: data.id });
    setIsModalVisible(true);
  };

  return (
    <div
      style={{
        fontSize: 16,
      }}
    >
      <Modal
        className="custom-modal-antd"
        style={{
          maxWidth: "100%",
          margin: 0,
          verticalAlign: "bottom",
          padding: 0,
          maxHeight: "90%",
        }}
        centered={true}
        footer={false}
        closable={false}
        open={isModalVisible}
        onCancel={handleCancel}
        maskStyle={{ backgroundColor: "rgba(0,0,0, 0.8)" }}
      >
        <div>
          <div
            style={{
              padding: "10px",
              maxHeight: "85vh",
              overflowY: "scroll",
            }}
          >
            <div
              style={{
                display: "flex",
                paddingBottom: "20px",
                alignItems: "center",
                position: "sticky",
                top: 0,
                background: "#ffffff",
                height: "108px",
              }}
            >
              <div style={{ marginRight: 10 }}>
                <img
                  style={{ width: 98, borderRadius: 8 }}
                  src={ArrPackage[indexPackage]?.imageLink}
                  alt="package"
                />
              </div>
              <div>
                <div style={{ color: "#F45454" }}>
                  <div style={{ fontWeight: 500, fontSize: 18 }}>
                    {ArrPackage[indexPackage]?.title}
                  </div>
                  <div style={{ fontSize: 12, color: "#646D69" }}>
                    Quyền lợi {_formatMoney(ArrPackage[indexPackage]?.price)}{" "}
                    VNĐ
                  </div>
                </div>
                <div
                  style={{
                    fontWeight: 500,
                    fontSize: 20,
                    marginTop: 2,
                    color: "#646D69",
                  }}
                >
                  <span>{_formatMoney(ArrPackage[indexPackage]?.fees)}</span>
                  <span style={{ color: "#9A9A9A", fontSize: 12 }}> VNĐ</span>
                </div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "10px 0px",
                marginBottom: 10,
                borderBottom: "1px solid #D9D9D9",
              }}
            >
              <div
                style={{
                  fontWeight: 500,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <img
                  style={{ width: 20, marginRight: 5 }}
                  src={IThoihan}
                  alt="quyen loi"
                />
                <span>Thời hạn bảo hiểm</span>
              </div>
              <div style={{ color: "#F45454", fontWeight: 500 }}>1 năm</div>
            </div>
            <div
              style={{
                padding: "0px 0px 10px 0px",
                marginBottom: 10,
                borderBottom: "1px solid #D9D9D9",
              }}
            >
              <div
                style={{
                  fontWeight: 500,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <img
                  style={{ width: 20, marginRight: 5 }}
                  src={IQuyenloi}
                  alt="quyen loi"
                />
                <span>Quyền lợi bảo hiểm</span>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 5,
              }}
            >
              <div
                style={{
                  fontWeight: 600,
                  display: "flex",
                  alignItems: "flex-start",
                }}
              >
                <img
                  style={{ width: 20, marginRight: 5 }}
                  src={ICheck}
                  alt="quyen loi"
                />
                <div>
                  <div style={{ marginBottom: 5 }}>
                    Tử vong, thương tật toàn bộ vĩnh viễn do tai nạn
                  </div>
                  <div style={{ fontSize: 12, fontWeight: 400 }}>
                    Tổng tiền bảo hiểm tối đa{" "}
                    {_formatMoney(ArrPackage[indexPackage]?.price)} VNĐ
                  </div>
                </div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  fontWeight: 500,
                  display: "flex",
                  alignItems: "flex-start",
                }}
              >
                <img
                  style={{ width: 20, marginRight: 5 }}
                  src={ICheck}
                  alt="quyen loi"
                />
                <div>
                  <div style={{ marginBottom: 5 }}>
                    Thương tật bộ phận vĩnh viễn do tai nạn
                  </div>
                  <div
                    style={{ fontSize: 12, marginBottom: 5, fontWeight: 400 }}
                  >
                    Tổng tiền bảo hiểm nhân với tỉ lệ thương tật vĩnh viễn
                  </div>
                </div>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  fontWeight: 500,
                  display: "flex",
                  alignItems: "flex-start",
                }}
              >
                <img
                  style={{ width: 20, marginRight: 5 }}
                  src={ICheck}
                  alt="quyen loi"
                />
                <div>
                  <div style={{ marginBottom: 5 }}>
                    Chi phí y tế điều trị thương tật do tai nạn/năm
                  </div>
                  <div
                    style={{ fontSize: 12, marginBottom: 5, fontWeight: 400 }}
                  >
                    Trả theo chi phí y tế thực
                    <br />
                    (tối đa{" "}
                    {_formatMoney(ArrPackage[indexPackage]?.benefitLimit)} VNĐ)
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style={{ height: 80 }}></div>
          <div className="footer">
            <Button onClick={() => goStep(3)} className="main-btn">
              Tiếp tục
            </Button>
          </div>
        </div>
      </Modal>
      <div style={{ padding: 15 }}>
        <div>
          <div style={{ marginBottom: 15 }}>
            <div style={{ fontWeight: 600, fontSize: 17 }}>
              Chọn gói bảo hiểm
            </div>
            <div style={{ fontSize: 12, color: "#9A9A9A" }}>
              Chọn một trong những gói bên dưới
            </div>
          </div>
          {(ArrPackage || []).map((data, i) => (
            <div
              key={i}
              style={{
                display: "flex",
                padding: "13px 16px",
                background: "#ffffff",
                borderRadius: 8,
                boxShadow: "0px 2px 5px rgba(0, 37, 18, 0.1)",
                border: "1px solid #D9D9D9",
                marginBottom: "20px",
              }}
              onClick={() => choosePackage(data, i)}
            >
              <div style={{ marginRight: 15 }}>
                <img
                  style={{ width: 90, borderRadius: 8 }}
                  src={data.imageLink}
                  alt={`hinh gói ${i + 1}`}
                />
              </div>
              <div>
                <div style={{ color: "#2A3790" }}>
                  <div
                    style={{
                      fontWeight: 600,
                      fontSize: 18,
                      color: "#EF4444",
                    }}
                  >
                    {data.title}
                  </div>
                  <div style={{ fontSize: 12, color: "#646D69" }}>
                    {data.subTitle}
                  </div>
                </div>
                <div style={{ marginTop: 15 }}>
                  <span style={{ fontWeight: 500, fontSize: 18 }}>
                    {_formatMoney(data.fees)}
                  </span>
                  <span style={{ color: "#9A9A9A" }}> VNĐ</span>
                </div>
              </div>
            </div>
          ))}
        </div>
        <img style={{ width: "100%" }} src={Hotline} alt="hotline" />
        <div style={{ height: 80 }}></div>
        <div className="footer">
          <button type="button" className="main-btn" onClick={() => goStep(1)}>
            Quay lại
          </button>
        </div>
      </div>
    </div>
  );
};

export default Package;
